/* eslint-disable jsx-a11y/label-has-associated-control */
import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Filter-Favorite.css';

export default function FilterFavorite() {
  const { filters, setFilters } = React.useContext(AppContext);
  const { favorite } = filters;
  function changeCheckboxFavorite() {
    setFilters({ ...filters, favorite: !favorite });
  }

  return (
    <div className="favorite-group">
      <input
        type="checkbox"
        className="favorite-group__input"
        id="checkbox"
        checked={favorite}
        onChange={changeCheckboxFavorite}
      />
      <label htmlFor="checkbox" className="favorite-group__label" />
    </div>
  );
}
